import React, { useState, useCallback } from 'react';
import { FieldProps, getIn } from 'formik';

import { SelectAsync as UiSelectAsync } from '../SelectAsync';

import { makeStyles } from '@material-ui/core/styles';
import { fromPairs } from 'lodash';
const useStyles = makeStyles(theme => ({
    root: {
    }
}));

export const SelectAsync = ({
    label,
    placeholder,
    loadOptions,
    getOptionLabel,
    getOptionValue,
    value,
    delay,
    disabled,
    onBlur,
    ...props }) => {
    const classes = useStyles();

    const {
        form: { setFieldValue, isSubmitting},
        field: { name: fieldName, onBlur: fieldOnBlur },
    } = props;

    const onChange = useCallback(
        (option) => {            
            setFieldValue(fieldName, option ? getOptionValue(option) : "");
        },
        [setFieldValue, fieldName]
    );

    return (
        <UiSelectAsync
            {...props}
            isClearable
            label={label}
            placeholder={placeholder || "Type to search..."}
            loadOptions={loadOptions}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            value={value}
            delay={delay}
            disabled={disabled ?? isSubmitting}
            onChange={onChange}
            onBlur={onBlur ?? function(e) { fieldOnBlur(e ?? fieldName); }}
        />
    );
}